<template>
    <Viagens></Viagens>
</template>
  
  <script>
  import Viagens from '../../components/viagens/Viagens.vue'
  export default {
    name: 'IndexViagens',
    components:{
      Viagens
    }
  }
  </script>